/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUserPaymentMethod201ResponseAllOfData } from './CreateUserPaymentMethod201ResponseAllOfData';
import {
    CreateUserPaymentMethod201ResponseAllOfDataFromJSON,
    CreateUserPaymentMethod201ResponseAllOfDataFromJSONTyped,
    CreateUserPaymentMethod201ResponseAllOfDataToJSON,
} from './CreateUserPaymentMethod201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateUserPaymentMethod201Response
 */
export interface CreateUserPaymentMethod201Response {
    /**
     * 
     * @type {CreateUserPaymentMethod201ResponseAllOfData}
     * @memberof CreateUserPaymentMethod201Response
     */
    data: CreateUserPaymentMethod201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateUserPaymentMethod201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateUserPaymentMethod201Response interface.
 */
export function instanceOfCreateUserPaymentMethod201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateUserPaymentMethod201ResponseFromJSON(json: any): CreateUserPaymentMethod201Response {
    return CreateUserPaymentMethod201ResponseFromJSONTyped(json, false);
}

export function CreateUserPaymentMethod201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserPaymentMethod201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateUserPaymentMethod201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateUserPaymentMethod201ResponseToJSON(value?: CreateUserPaymentMethod201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateUserPaymentMethod201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

